<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        head: {
			title: { inner: 'Your Tennis match history in one place', separator: '|', complement: 'Str8 Sets' },
            meta: [
				{ name: 'description', content: 'Whether it\'s competition or social tennis matches that you play, Str8 Sets records them all for you. Your tennis ability is the sum of all your tennis matches and now you can store that data directly in the Str8 Sets app.', id: 'desc'},
                { property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'https://www.str8sets.com/tennis_match_diary' },
                { property: 'og:title', content: 'Your Tennis match history in one place | Str8 Sets' },
                { property: 'og:description', content: 'Whether it\'s competition or social tennis matches that you play, Str8 Sets records them all for you. Your tennis ability is the sum of all your tennis matches and now you can store that data directly in the Str8 Sets app.' },
                { property: 'og:image', content: 'https://www.str8sets.com/img/meta_str8sets_comps_circle_matches_1200x628.jpg' },   
				{ property: 'og:image:alt', content: 'Str8 Sets Tennis Logo and App Screenshots' },            
                { name: 'twitter:site', content: 'str8sets' },
				{ name: 'twitter:creator', content: '@str8sets' },
				{ name: 'twitter:card', content: 'summary_large_image' },  
				{ name: 'twitter:url', content: 'https://www.str8sets.com/tennis_match_diary' },
				{ name: 'twitter:title', content: 'Your Tennis match history in one place | Str8 Sets' },
                { name: 'twitter:description', content: 'Whether it\'s competition or social tennis matches that you play, Str8 Sets records them all for you. Your tennis ability is the sum of all your tennis matches and now you can store that data directly in the Str8 Sets app.' },
				{ name: 'twitter:image', content: 'https://www.str8sets.com/img/meta_str8sets_comps_circle_matches_1200x628.jpg' },
				{ name: 'twitter:image:alt', content: 'Str8 Sets Tennis Logo and App Screenshots' }
            ],
            link: [
      			{ rel: 'canonical', href: 'https://www.str8sets.com/tennis_match_diary', id: 'canonical' }
			]
        }
    })
</script>

<template>
    <div>

        <div class="parallax parallax image-player-serving-legs height-350">
            <div class="container">
                <div class="feature-page-header">
                    <h1>Match Diary</h1>
                    <h2>All your matches in one place</h2>
                </div>
                <div class="row">
                    <router-link class="clear_button" to="/faq#matches" role="button">FREQUENT QUESTIONS</router-link>
                </div>
            </div>
        </div> 

        <section class="feature-list section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <p>Your tennis ability is the sum of all your tennis matches. That data is valuable! <strong>Str8 Sets allows you to record every 
                            single match you play</strong> under your Matches screen in the app. Competition matches are automatically recorded after a score has been 
                            entered via the Competition section. However, you can also enter every match you play socially or in competitions that are not run on 
                            Str8 Sets. Don't lose track of your history!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spacer-large"></div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 heading">
                        <img class="icon" src="@/assets/images/matches.svg" alt="Green Matches Icon" data-no-retina>
                        <h2>How it works</h2>
                        <h4>Record your match results!</h4>
                    </div>                            
                </div>
                <div class="row">                               
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <p>The Matches screen presents you with all of your matches recorded on Str8 Sets. Str8 Sets 
                            Competition matches are automatically included once a score is entered, so you shouldn't add them manually.</p>
                            
                            <p>On this screen you can filter matches by match type or surface, which gives you greater granularity over 
                            your view. Matches outside Str8 Sets Competitions need to be confirmed by at least one player on either side. 
                            If your opponent entered a match against you, you would need to confirm the score on this screen.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="spacer-large"></div>
            <div class="container">
                <div class="row text-center">
                    <img class="img_inrow" :src="'/img/iphone_matches_243x440.jpg'" alt="Str8 Sets App Screenshot (iPhone, Matches)" v-rjs="2">
                    <img class="img_inrow" :src="'/img/iphone_matchadd_243x440.jpg'" alt="Str8 Sets App Screenshot (iPhone, Add Match)" v-rjs="2">
                </div> 
            </div>
        </section>

        <div class="parallax parallax image-player-serving-legs height-150" ></div>

        <section class="feature-list section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="content mt-100">
                            <div class="text-heading">
                                <h2>Adding a New Match</h2>
                            </div> 
                            <p>Adding a new match allows you to record the date, surface, duration, and score of that match. 
                            Of course, you will need to enter your opponent's email. A valid email is required to identify your 
                            opponent. If your opponent is already on Str8 Sets please make sure that you use one of their registered 
                            emails.</p>
                            <p>When adding your opponent(s), it is critical to make sure you add valid email addresses for them.</p>
                        </div>
                    </div>
                </div>
                <div class="spacer-large"></div>
            </div>
        </section>

    </div>
</template>